import connect from 'components/lib/connect';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

import { ButtonTypes } from 'components/common/button';
import ConfirmOrCancelModal from 'components/common/confirm_or_cancel_modal';
import CloseModal from 'actions/modal/close_modal';
import DeleteFacebookComment from 'actions/facebook_comments/delete_facebook_comment';
import { MessageChannelType } from 'models/conversation_message';

function DeleteFacebookCommentModal(props) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = () => {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    props.onConfirm({
      commentId: props.commentId,
    });
  };

  return <ConfirmOrCancelModal {...props} onSubmit={onSubmit} submitButtonDisabled={isSubmitting} />;
}

DeleteFacebookCommentModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  commentId: PropTypes.string.isRequired,
};

const DeleteFacebookCommentModalContainer = connect(mapStateToProps, mapExecuteToProps)(DeleteFacebookCommentModal);

export { DeleteFacebookCommentModal };
export default DeleteFacebookCommentModalContainer;

function mapStateToProps({ getProvider }) {
  const modalAttrs = getProvider('modal').get();

  return {
    commentId: modalAttrs.commentId,
    title: 'Delete comment',
    submitText: 'Delete comment',
    text: (
      <>
        {modalAttrs.channel === MessageChannelType.FB_COMMENT ? (
          <Trans>Are you sure you want to delete this comment from Facebook? This action cannot be undone.</Trans>
        ) : (
          <Trans>Are you sure you want to delete this comment from Instagram? This action cannot be undone.</Trans>
        )}
        <br />
        <Trans>The comment will remain visible on the Conversation Timeline</Trans>
      </>
    ),
    submitButtonType: ButtonTypes.DANGER,
  };
}

function mapExecuteToProps(executeAction) {
  return {
    onCancel: () => {
      executeAction(CloseModal);
    },
    onConfirm: props => {
      executeAction(DeleteFacebookComment, props);
    },
  };
}
